import { EXISTING_PROJECT_LIST, CREATE_PRE_SALE_SUPPLY,CLIENT_LIST, GET_SOLUTION, GET_ALL_QUOTATIONS, GET_QUOTATION, QUOTATION_HISTORY } from "./type";

const initalState = {
  existingProjectList: [],
  submitSuccess: {},
  clientListing:[],
  solution:{},
  allQuotations: [],
  quotation: [],
  quotationHistory: []
};

const projectOnboardingReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case EXISTING_PROJECT_LIST:
      return {
        ...state,
        existingProjectList: payload,
      };

    case CREATE_PRE_SALE_SUPPLY:
      return {
        ...state,
        submitSuccess: payload,
      };

    case CLIENT_LIST:
        return {
          ...state,
          clientListing: payload,
      };
    case GET_SOLUTION:
      return {
        ...state,
        solution: payload,
    };    
    case GET_ALL_QUOTATIONS:
      return {
        ...state,
        allQuotations: payload,
    };
    case GET_QUOTATION:
      return {
        ...state,
        quotation: payload,
    };        
    case QUOTATION_HISTORY:
      return {
        ...state,
        quotationHistory: payload,
    };   
    default:
      return {
        ...state,
      };
  }
};

export default projectOnboardingReducer;
